import React, { useEffect, useRef, useState } from "react";
import "../styles/CountPage.css";
import AnimatedTitle from "../components/AnimatedTitle";
import CountUp from "react-countup";

import AOS from "aos";
import "aos/dist/aos.css";

import logoImg from "../assets/van-logo.png";
import videoFile from "../assets/vanvid.mp4";

/* COUNT ICONS */
import fleetIcon from "../assets/drive.png";
import milesIcon from "../assets/miles.png";
import bookingIcon from "../assets/booking.png";
import pickupIcon from "../assets/loc.png";

/* SLIDING IMAGES */
import img1 from "../assets/tt11.png";
import img2 from "../assets/tt6.png";
import img3 from "../assets/tt23.png";
import img4 from "../assets/tt14.png";
import img5 from "../assets/tt15.png";
import img6 from "../assets/tt16.png";
import img7 from "../assets/tt17.png";
import img8 from "../assets/tt18.png";
import img9 from "../assets/tt27.jpeg";
import img10 from "../assets/tt20.png";

const leftImages = [img1, img2, img3, img4, img5];
const rightImages = [img6, img7, img8, img9, img10];

/* ====== CUSTOM HOOK FOR SCREEN SIZE ====== */
const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () =>
      setSize({ width: window.innerWidth });

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
};

const CountPage = () => {
  const { width } = useWindowSize();
  const isMobileOrTablet = width <= 1024;
  
  useEffect(() => {
    document.title =
      "Experience | 18 Seater Tempo Traveller in Mayiladuthurai | Maha Cabs";

    const setMeta = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Book premium 18-seater AC Tempo Traveller in Mayiladuthurai with experienced driver, clean interiors, safe travel, and affordable pricing. Best for family trips, hill stations, temples, and outstation tours."
    );

    setMeta(
      "keywords",
      "tempo traveller in mayiladuthurai, 18 seater tempo traveller mayiladuthurai, ac tempo traveller mayiladuthurai, tempo traveller hire mayiladuthurai, best tempo traveller service mayiladuthurai, maha cabs tempo traveller, luxury tempo traveller mayiladuthurai"
    );
  }, []);
  // ================================================

  // ✅ Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <section className="count-section">
      <div className="count-container">

        {/* LEFT SIDE */}
        <div className="count-left">

          <img 
            src={logoImg} 
            alt="Maha Cabs Tempo Traveller Service in Mayiladuthurai" 
            className="count-logo" 
          />

          <AnimatedTitle
            text={`EXPERIENCE ON 
OUR VAN BOOKING SERVICE`}
            className="service-title"
          />

          <p>
            With over 30+ years of trusted travel experience, our van rental
            service offers safe, reliable, and comfortable transportation for
            all your travel needs. Our vehicles are clean and well-maintained
            to ensure maximum safety and comfort for every passenger.
          </p>

          {/* COUNT CARDS WITH AOS FADE-UP */}
          <div className="count-grid">

            <div className="count-card yellow"
              data-aos="fade-up"
              data-aos-delay="100">
              <div className="card-inner">
                <img src={fleetIcon} alt="30 years tempo traveller driving experience" className="count-icon" />
                <span className="count-number">
                  <CountUp end={30} duration={4} enableScrollSpy scrollSpyOnce />+
                </span>
                <p>Driving Exp</p>
              </div>
            </div>

            <div className="count-card dark"
              data-aos="fade-up"
              data-aos-delay="200">
              <div className="card-inner">
                <img src={milesIcon} alt="Millions of miles driven by Maha Cabs" className="count-icon" />
                <span className="count-number">
                  <CountUp end={10} duration={4} enableScrollSpy scrollSpyOnce />M+
                </span>
                <p className="p1">Miles of drive</p>
              </div>
            </div>

            <div className="count-card dark"
              data-aos="fade-up"
              data-aos-delay="300">
              <div className="card-inner">
                <img src={bookingIcon} alt="Thousands of tempo traveller bookings" className="count-icon" />
                <span className="count-number">
                  <CountUp end={20} duration={4} enableScrollSpy scrollSpyOnce />K+
                </span>
                <p className="p1">Booking reserved</p>
              </div>
            </div>

            <div className="count-card yellow"
              data-aos="fade-up"
              data-aos-delay="400">
              <div className="card-inner">
                <img src={pickupIcon} alt="Tempo traveller pickup and drop service" className="count-icon" />
                <span className="count-number">
                  <CountUp end={50} duration={4} enableScrollSpy scrollSpyOnce />K+
                </span>
                <p>Pickup & drop</p>
              </div>
            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        {!isMobileOrTablet ? (
          <div className="count-right multi-layout">

            <div className="image-column slide-down">
              {[...leftImages, ...leftImages].map((img, i) => (
                <img 
                  src={img} 
                  alt="18 seater AC Tempo Traveller in Mayiladuthurai" 
                  key={i} 
                />
              ))}
            </div>

            <div className="video-center">
              <video autoPlay muted loop playsInline>
                <source src={videoFile} type="video/mp4" />
              </video>
            </div>

            <div className="image-column slide-up">
              {[...rightImages, ...rightImages].map((img, i) => (
                <img 
                  src={img} 
                  alt="Luxury Tempo Traveller for family and group trips" 
                  key={i} 
                />
              ))}
            </div>

          </div>
        ) : (
          <div className="count-right mobile-layout">

            <div className="carousel-track slide-ltr">
              <div className="carousel-inner">
                {[...leftImages, ...leftImages, ...leftImages].map((img, i) => (
                  <img 
                    src={img} 
                    alt="Best Tempo Traveller in Mayiladuthurai" 
                    key={i} 
                  />
                ))}
              </div>
            </div>

            <div className="mobile-video-center">
              <video autoPlay muted loop playsInline>
                <source src={videoFile} type="video/mp4" />
              </video>
            </div>

            <div className="carousel-track slide-rtl">
              <div className="carousel-inner">
                {[...rightImages, ...rightImages, ...rightImages].map((img, i) => (
                  <img 
                    src={img} 
                    alt="Maha Cabs 18 seater AC Tempo Traveller" 
                    key={i} 
                  />
                ))}
              </div>
            </div>

          </div>
        )}

      </div>
    </section>
  );
};

export default CountPage;
